import * as React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { quitterCoach, useMoi } from '../Auth/moi.ts';
import { OFFRES } from '../Auth/ChoixProfil.tsx';

/**
 * Offre de l'utilisateur (page Mes preferences) : profil athlete ou coach
 * choisi a la premiere connexion, definitif (cf ChoixProfil), et pour
 * l'athlete suivi, son coach qu'il peut quitter.
 */
export default function OffreEditeur() {
  const moi = useMoi();
  const [erreur, setErreur] = React.useState<string | null>(null);
  const offre = OFFRES.find((o) => o.role === moi?.role);

  const quitter = async () => {
    if (!moi?.coach) return;
    if (!window.confirm(`Quitter ton coach (${moi.coach}) ? Il n'aura plus accès à ton calendrier, qui est conservé.`)) return;
    setErreur(null);
    try {
      await quitterCoach();
    } catch (e) {
      setErreur('Action impossible : ' + (e as Error).message);
    }
  };

  if (!moi) return null;

  return (
    <Box sx={{ maxWidth: 560 }}>
      <h2>Mon offre produit</h2>
      {offre ? (
        <>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
            <Typography variant="h6">{offre.titre}</Typography>
            <Chip size="small" color={offre.role === 'COACH' ? 'primary' : 'success'} label={offre.prix} />
          </Stack>
          {offre.description.map((d) => (
            <Typography key={d} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              • {d}
            </Typography>
          ))}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Choisie à ta première connexion, ton offre ne peut pas être modifiée depuis l'application.
          </Typography>
        </>
      ) : (
        <Typography color="text.secondary">Aucune offre choisie.</Typography>
      )}

      {(offre?.role === 'ATHLETE' || moi.coach) && (
        <Box sx={{ mt: 4 }}>
          <h2>Mon coach</h2>
          {moi.coach ? (
            <Stack direction="row" alignItems="center" spacing={2} useFlexGap flexWrap="wrap">
              <Typography>{moi.coach} établit ton calendrier.</Typography>
              <Button size="small" color="error" variant="outlined" onClick={quitter}>
                Quitter mon coach
              </Button>
            </Stack>
          ) : (
            <Typography color="text.secondary">
              Aucun coach ne te suit. Un coach peut t'inviter avec l'adresse de ton compte Google.
            </Typography>
          )}
          {erreur && <Alert severity="error" sx={{ mt: 2 }}>{erreur}</Alert>}
        </Box>
      )}
    </Box>
  );
}
